import { render, staticRenderFns } from "./Doubt.vue?vue&type=template&id=61b0bf76&scoped=true&"
import script from "./Doubt.vue?vue&type=script&lang=js&"
export * from "./Doubt.vue?vue&type=script&lang=js&"
import style0 from "./Doubt.vue?vue&type=style&index=0&id=61b0bf76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0bf76",
  null
  
)

export default component.exports